<div class="installations layout-spacing" data-testid="installations">
    <div class="installations__stats">
        @for (stat of statsData; track stat.title) {
            <app-stats-card [statsData]="stat" [hasTotal]="true" width="100%"></app-stats-card>
        }
    </div>

    <div class="installations__content" data-testid="installations-content">
        <app-table-toolbar
            [placeholder]="'Search License Key, Host, Dealer Alias or Business Name'"
            [buttons]="toolbarButtons()"
            (actionClick)="onToolbarAction($event)"
            (searchValueChange)="onSearch($event)">
            <ntv-dropdown
                leftActions
                [config]="sortConfig()"
                (selectionChange)="onSortChange($event)">
            </ntv-dropdown>
        </app-table-toolbar>

        <div
            class="installations__content-table main-table-container"
            data-testid="installations-content-table">
            <app-table
                [columns]="licenseColumns"
                [data]="tableData()"
                [loading]="isLoading()"
                [tableTitle]="'Installations'"
                [tableHeight]="'780px'"
                [hasCheckBox]="true"
                (actionClick)="onActionClick($event)"
                (selectionChange)="onSelectionChange($event)">
            </app-table>
        </div>
    </div>
</div>
